import React, { useEffect, useState } from "react";
import jwt_decode from "jwt-decode";
import { toast } from "react-toastify";
import ArticleListing from "../../../components/dashboard/ArticleListing";
import "./index.scss";
import downarrow from "../../../assets/img/icons/downarrow.svg";
import Nav from "react-bootstrap/Nav";
import Tab from "react-bootstrap/Tab";
import Modal from "react-bootstrap/Modal";
import { Link, useLocation, useNavigate } from "react-router-dom";
import DashboardLayout from "../../../layout/dashboard";
import {
  getArticleDetails,
  getSearchUsers,
  getPEDetails,
  appointPRRole,
  inviteExternalPrSociety,
} from "../../../store/apiCalls/dashboard";
import PEListing from "./PEListing";
// E:\React JS\ag-front\src\components\common\Select.js
import Select from "../../../components/common/Select";
import { getAllMasterData } from "../../../store/apiCalls/fetchmaster";
import { useSelector, useDispatch } from "react-redux";
import RecommendedArticles from "../dashboard/RecommendedArticles";

const PRListing = () => {
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state?.LoginReducer);
  const [show, setShow] = useState(false);
  const [successPrAssign, setSuccessPrAssign] = useState(false);
  const handleClose = () => setShow(false);
  const [updateRequestList, setUpdateRequestList] = useState(false);
  const [amendmentUpdateTrigger, setAmendmentUpdateTrigger] = useState(false);
  const [updateTrigger, setUpdateTrigger] = useState(false);
  const [successAssign, setsuccessAssign] = useState(false);
  const [addPeerReviewerPop, setaddPeerReviewerPop] = useState(false);
  const { id } = jwt_decode(localStorage.usertoken);
  const [activeTab, setActiveTab] = useState("draft");
  const location = useLocation();
  const [peActiveTab, setPEActiveTab] = useState("draft");
  const [peData, setPEData] = useState([]);
  const [updatedData, setUpdatedData] = useState([]);
  // console.log("updatedData",updatedData);
  const [totalPEData, setTotalPEData] = useState([]);
  const [peerreviewlist, setpeerreviewlist] = useState([
    {
      name: "",
      email: "",
      university: "",
      subject: "",
    },
  ]);
  const [articleData, setArticleData] = useState([]);
  const [search, setSearch] = useState("");
  const [searchResult, setSearchResult] = useState([]);
  const [allUsers, setAllUsers] = useState([]);
  const [Subjectmaster, setSubjectmaster] = useState([]);
  const [assignedArticleJournalNameState, setAssignedArticleJournalNameState] =
    useState("");
  const JOURNAL_HELP_EMAIL_MAP = {
    "Applied and Basic Obesity, Diabetes and Endocrinology":
      "editorinchief@abodejournal.com",
    "Minorities in World Politics": "journal.mwp@gmail.com",
    "Community Learning and Social Transformation": "Editor@readindia.com",
  };

  const [articleTotalData, setArticleTotalData] = useState([]);
  const [page, setPage] = useState(1);
  const limit = 10;
  const headers = { Authorization: `Bearer ${localStorage?.usertoken}` };

  const articleId = location?.state?._id;
  const reassignStatus = location?.state?.reassignStatus;

  const [collapseActive, setIsActive] = useState(false);
  const expandClick = (event) => {
    setIsActive((current) => !current);
  };
  async function getMasterList() {
    const msterlst = await getAllMasterData();

    if (msterlst.status === 200) {
      const subjectLists = [];
      const subjectSpecialization = [];
      msterlst.data.subjectdata.forEach((element) => {
        const data = { key: element._id, value: element.subjectName };
        subjectLists.push(data);
        subjectSpecialization[element._id] = element.specializationId;
      });

      setSubjectmaster(subjectLists);
      // setSubjectmaster(msterlst.data.specializationdata);
      //   setspecializationList(msterlst.data.specializationdata);
      //   const journalMaster = [];
      //   const journalType = [];
      //   msterlst.data.jouranlData.forEach((element) => {
      //     const data = { key: element._id, value: element.journalType };
      //     journalType.push(data);
      //     journalMaster[element._id] = element.journalName;
      //   });

      //   setgernalMaster(journalMaster);
      //   setgernalType(journalType);
      //   setdesciplineMaster(msterlst.data.disciplineData);
    }
  }

  const fetchPublishingEditor = async (tab) => {
    dispatch({ type: "SET_LOADER", payload: true });
    const params = {
      userId: id,
      page: page,
      limit,
      peStatus: tab,
    };
    const response = await getPEDetails(headers, params);
    if (response?.status === 200) {
      dispatch({ type: "SET_LOADER", payload: false });
      setPEData(response?.data?.data?.data);
      setTotalPEData(response?.data?.data);
    } else {
      dispatch({ type: "SET_LOADER", payload: true });
      return toast.error("Please try again");
    }
  };

  const getPEType = (type) => {
    fetchPublishingEditor(type);
    setPEActiveTab(type);
  };
  // Journal info of the currently logged-in society editor
  const editorJournalType = user?.journalType;
  const editorJournalName = user?.journalName;

  /**
   * Client-side filter: does a user record match the search term?
   * Checks fullName, email, Education subject, subjectOfInterest subjects,
   * affiliation subjects, and Education specialization.
   */
  const matchesSearch = (userRecord, term) => {
    if (!term || term.trim() === "") return true;
    const q = term.toLowerCase();

    // Name / email
    if (userRecord?.fullName?.toLowerCase().includes(q)) return true;
    if (userRecord?.email?.toLowerCase().includes(q)) return true;

    // Education subject
    const eduSubject = userRecord?.Education?.subject?.subjectName;
    if (eduSubject?.toLowerCase().includes(q)) return true;

    // Education specializations (discipline)
    const eduSpecs = userRecord?.Education?.specialization || [];
    if (eduSpecs.some((s) => s?.specialization?.toLowerCase().includes(q))) return true;

    // Subject of interest
    const subjectOfInterest = userRecord?.subjectOfInterest || [];
    for (const si of subjectOfInterest) {
      if (si?.interestedsubject?.subjectName?.toLowerCase().includes(q)) return true;
      const siSpecs = si?.specialization || [];
      if (siSpecs.some((s) => s?.specialization?.toLowerCase().includes(q))) return true;
    }

    // Affiliation subjects
    const affiliations = userRecord?.affiliation?.affiliations || [];
    for (const aff of affiliations) {
      if (aff?.subject?.subjectName?.toLowerCase().includes(q)) return true;
      const affSpecs = aff?.specialization || [];
      if (affSpecs.some((s) => s?.specialization?.toLowerCase().includes(q))) return true;
    }

    return false;
  };

  /**
   * Checks whether a user record belongs to the same journal as the editor.
   */
  const matchesEditorJournal = (userRecord) => {
    const journalTypeToUse = user?.journalType || "Society Journal";
    const journalNameToUse = user?.journalName || assignedArticleJournalName;
    if (!journalTypeToUse && !journalNameToUse) return true; // no filter if editor has no journal set
    const userJournalType = userRecord?.journalType;
    const userJournalName =
      userRecord?.journalName ||
      userRecord?.journal?.journalName ||
      userRecord?.journal;
    const typeMatch = journalTypeToUse
      ? userJournalType === journalTypeToUse
      : true;
    const nameMatch = journalNameToUse
      ? userJournalName === journalNameToUse
      : true;
    return typeMatch && nameMatch;
  };

  /*search by name, email, subject, discipline */
  const searchByName = async (searchTerm) => {
    const activate = true;
    const journalTypeToUse = user?.journalType || "Society Journal";
    const journalNameToUse = user?.journalName || assignedArticleJournalName;
    let data = {
      page,
      limit,
      search: searchTerm,
      activate,
      ...(journalTypeToUse && { journalType: journalTypeToUse }),
      ...(journalNameToUse && { journalName: journalNameToUse }),
    };
    const response = await getSearchUsers(headers, data);
    const fetched = response?.data?.data?.data || [];
    const filtered = fetched
      .filter((u) => matchesEditorJournal(u))
      .filter((u) => matchesSearch(u, searchTerm));
    setAllUsers(fetched);
    setSearchResult(filtered);
  };

  const fetchArticleData = async (tab) => {
    dispatch({ type: "SET_LOADER", payload: true });
    const params = {
      userId: id,
      status: tab,
      page: page,
      limit: limit,
    };
    const response = await getArticleDetails(headers, params);
    if (response?.status === 200) {
      dispatch({ type: "SET_LOADER", payload: false });
      setArticleData(response?.data?.data?.article);
      setArticleTotalData(response?.data?.data);
    } else {
      dispatch({ type: "SET_LOADER", payload: false });
      return toast.error("Please try again");
    }
  };

  const getArticleType = (type) => {
    fetchArticleData(type);
    setActiveTab(type);
  };
  async function assignReviwer(PeId, journalNameOverride = "") {
    if (journalNameOverride) {
      setAssignedArticleJournalNameState(journalNameOverride);
    }
    // const headers = { Authorization: `Bearer ${adminToken}` };
    // const articleId = window.location.pathname.split("/")[5];
    const data = {
      articleId: articleId,
      singlePE: PeId,
    };
    const response = await appointPRRole(headers, data);
    // const saveData = { headers: headers, payload: data };
    // const response = await httpPost(
    //   `${URLS.AAKASHGANGA.APPOINTPRFORARTICLE}`,
    //   data,
    //   headers
    // );
    console.log("appointPRRole response:", response);
    if (response?.status === 200) {
      setSuccessPrAssign(true);
      // Main Backend returns { success: true, data: { articleFlow, peerReviewer, articleTitle } }
      // Proxy optionally wraps it in { data: ... }
      const rawBody = response?.data?.data
        ? response.data.data
        : response?.data;
      const payload = rawBody?.data ? rawBody.data : rawBody;

      console.log("Final Extracted payload for modal:", payload);
      setUpdatedData(payload);
    } else {
      toast.error("Please try again!!");
    }
  }

  const assignedArticleJournalName =
    updatedData?.articleFlow?.article?.[0]?.submissionDetail?.journalName ||
    updatedData?.article?.[0]?.submissionDetail?.journalName ||
    updatedData?.submissionDetail?.journalName ||
    location?.state?.journalName ||
    assignedArticleJournalNameState ||
    editorJournalName ||
    "";
  const helpEmailForAssignedArticle =
    JOURNAL_HELP_EMAIL_MAP[assignedArticleJournalName] ||
    "contactus@vikramshilaedu.in";
  const invitePEhandleUpdate = (index, updatedFields) => {
    setpeerreviewlist((prevList) => {
      const newList = [...prevList];
      newList[index] = { ...newList[index], ...updatedFields };
      return newList;
    });
  };
  // Handle adding a new peer review
  const handleAdd = () => {
    setpeerreviewlist((prevList) => [
      ...prevList,
      { name: "", email: "", university: "", subject: "" },
    ]);
  };

  // Email format validation
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  // Handle submit – validate emails then call the invite API
  const handleInviteSubmit = async () => {
    for (const reviewer of peerreviewlist) {
      if (!reviewer.name || reviewer.name.trim() === "") {
        return toast.error("Please enter the name for all reviewers.");
      }
      if (!reviewer.email || !emailRegex.test(reviewer.email.trim())) {
        return toast.error(
          `Invalid email address: "${reviewer.email}". Please enter a valid email.`
        );
      }
    }

    try {
      const response = await inviteExternalPrSociety(headers, {
        reviewers: peerreviewlist,
        articleId: articleId,
      });
      console.log("responseExternal :", response)

      if (response?.status === 200) {
        setaddPeerReviewerPop(false);
        // Reset the list for next use
        setpeerreviewlist([{ name: "", email: "", university: "", subject: "" }]);
        toast.success("Invitation emails sent successfully!");
      } else if (response?.response?.status === 409 || response?.status === 409) {
        const msg =
          response?.response?.data?.message ||
          response?.data?.message ||
          "This researcher is already registered. Please find them in the search bar below.";
        toast.error(msg);
      } else if (response?.response?.status === 400 || response?.status === 400) {
        const msg =
          response?.response?.data?.message ||
          response?.data?.message ||
          "Invalid input. Please check all fields.";
        toast.error(msg);
      } else {
        toast.error("Failed to send invitations. Please try again.");
      }
    } catch (err) {
      toast.error("Something went wrong. Please try again.");
    }
  };

  // Handle removing a peer review
  const handleRemove = (index) => {
    setpeerreviewlist((prevList) => {
      const newList = [...prevList];
      newList.splice(index, 1);
      return newList;
    });
  };

  useEffect(() => {
    getMasterList();
    // Pre-populate the peer reviewer table on mount with all users matching editor's journal
    searchByName("");
  }, []);
  useEffect(() => {
    if (updateTrigger) {
      fetchArticleData("published");
    } else if (amendmentUpdateTrigger) {
      fetchArticleData("published");
    } else {
      fetchArticleData("draft");
    }
    localStorage.setItem("getPEType", "");
    fetchPublishingEditor("draft");
    setIsActive(true);
  }, [page, updateTrigger, amendmentUpdateTrigger, updateRequestList]);
  const profileAs = localStorage.getItem("dropdownToggleVal");

  console.log("updatedData?.articleTitle :", updatedData?.articleTitle);

  return (
    <>
      <DashboardLayout>
        <>
          <div className="d-flex justify-content-between">
            <p className="draftTitle">
              Assign Peer Reviewer
              <span>
                <span>
                  Please search the Peer Reviewer below to{" "}
                  {reassignStatus ? "reassign" : "assign"} the article to them.
                </span>
              </span>
            </p>
            <span
              onClick={() => setaddPeerReviewerPop(true)}
              className="addpeerreviews-btn cursor-pointer flex-wrap justify-content-start"
              style={{ flexBasis: "40%", paddingLeft: "7.5%" }}
            >
              Invite Peer Reviewers here <span className="icon">+</span>
              <span
                style={{
                  display: "block",
                  color: "#000",
                  fontWeight: 400,
                  textTransform: "none",
                  fontSize: "16px",
                  fontFamily: '"Inter", sans-serif',
                }}
              >
                This action sends invitation email on behalf of the society.
              </span>
            </span>
          </div>
          <div>
            <input
              placeholder="Search by Name, Email, Subject or Discipline"
              name="search"
              className="searchpr"
              style={{ minWidth: "590px", minHeight: "50px" }}
              value={search}
              onChange={(event) => {
                setSearch(event.target.value);
                searchByName(event.target.value);
              }}
            />
          </div>
          <div className="mt-4">
            <table className="table tableadmin">
              <thead>
                <tr>
                  <th>User</th>
                  <th>Journal</th>
                  <th>Contact</th>
                  <th>Nationality</th>
                  <th>Registered</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {searchResult.map((list) => (
                  <>
                    <tr key={list?._id}>
                      <td>
                        <span className="text-link">{list?.fullName}</span>
                      </td>
                      <td>{list?.journalName || list?.journal?.journalName || "--"}</td>
                      <td>
                        <span>{list?.email}</span>
                        <br />
                        <span>{list?.phoneNumber}</span>
                      </td>
                      <td>
                        {list?.nationality === "withInIndia"
                          ? "Within India"
                          : "Outside India"}
                      </td>
                      <td>
                        {new Date(list?.createdAt).toLocaleDateString("en-GB", {
                          day: "numeric",
                          month: "short", // 'short' gives abbreviated month names like "Sep"
                          year: "numeric",
                        })}
                      </td>
                      <td>
                        <span
                          className="text-link"
                          onClick={() =>
                            assignReviwer(
                              list?._id,
                              list?.journalName ||
                              list?.journal?.journalName ||
                              editorJournalName ||
                              "",
                            )
                          }
                        >
                          Assign
                        </span>
                      </td>
                    </tr>
                  </>
                ))}
              </tbody>
            </table>
          </div>
        </>
        <Modal
          show={show}
          onHide={handleClose}
          dialogClassName="modal-dialog-centered modal-lg authorModal"
        >
          <Modal.Header className="modal-header">
            <h5 className="modal-title">Grant Details</h5>
            <button
              type="button"
              className="btn-close"
              ariaLabel="Close"
              onClick={(e) => handleOTPClose(e)}
            />
          </Modal.Header>
          <Modal.Body className="pb-0">
            <div className="grantDetails">
              <div className="row">
                <div className="col-md-6">
                  <div className="infotext">
                    <b>Grant Name</b>
                    <span className="textGreen">
                      Vikramshila Grant for Authors
                    </span>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="infotext">
                    <b>Available for</b>
                    <span className="textGreen">
                      Vikramshila Grant for Authors
                    </span>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-12">
                  <div className="infotext">
                    <b>URL of Grant available for </b>
                    <span className="textBlue">
                      Urban climate change management and society
                    </span>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-12">
                  <div className="infotext">
                    <b>Description</b>
                    <span className="textGray">
                      Lorem ipsum dolor sit amet, consectetur adipiscing elit,
                      sed do eiusmod tempor incididunt ut labore et dolore magna
                      aliqua. Ut enim ad minim veniam, quis labore et dolore
                      magna aliqua labore et dolore magna...
                    </span>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-12">
                  <div className="infotext">
                    <b>Eligibility</b>
                    <ul className="listText">
                      <li>
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit
                      </li>
                      <li>
                        Sed do eiusmod tempor incididunt ut labore et dolore
                        magna aliqua
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-12">
                  <div className="infotext">
                    <b>Know More</b>
                    <ul className="knowList">
                      <li>
                        <p>
                          <i>Grant Received On</i>
                          <small>12 May 2023</small>
                        </p>
                        <p>
                          <i>Valid Till</i>
                          <small>25 Aug 2023</small>
                        </p>
                      </li>

                      <li>
                        <p>
                          <i>Amount Received</i>
                          <small>INR 7000</small>
                        </p>
                        <p>
                          <i>Amount Remaining</i>
                          <small>INR 6500</small>
                        </p>
                      </li>
                      <li>
                        <p>
                          <i>Transaction ID</i>
                          <small>826475844855</small>
                        </p>
                        <p>
                          <i>Invoice</i>
                          <div className="downloadBOx">
                            <a href="" download></a>
                            <strong>Download</strong>
                          </div>
                        </p>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer className="pb-4">
            <button
              class="button button-primary"
              type="submit"
              onClick={handleClose}
            >
              CLOSE
            </button>
          </Modal.Footer>
        </Modal>
        <Modal
          show={successPrAssign}
          //onHide={setSuccessPrAssign(false)}
          dialogClassName="modal-dialog-centered authorModal"
        >
          <Modal.Header className="modal-header pb-2">
            <h5 className="modal-title">
              Peer Reviewer {reassignStatus ? "Reassigned" : "Assigned"}
            </h5>
            <button
              type="button"
              className="btn-close"
              ariaLabel="Close"
              onClick={(e) => setSuccessPrAssign(false)}
            />
          </Modal.Header>
          <Modal.Body className="pb-0 pt-0">
            <p>
              You have succesfully {reassignStatus ? "reassigned" : "assigned"}{" "}
              the following <br /> peer reviewer for the selected article:
            </p>
            <br />
            <p style={{ paddingLeft: "32px" }} className="text-left fw-bold">
              Peer Reviewer:{" "}
              <span className="fw-normal">
                {updatedData?.peerReviewer?.title}{" "}
                {updatedData?.peerReviewer?.fullName}
              </span>
            </p>
            <p style={{ paddingLeft: "32px" }} className="text-left fw-bold">
              Article:{" "}
              <span className="fw-normal">
                {updatedData?.articleTitle}
              </span>{" "}
            </p>
          </Modal.Body>
          <Modal.Footer className="pb-2">
            {/* <button
                            class="button "
                            type="submit"
                            onClick={(e) => setSuccessPrAssign(false)}
                        >
                           Cancel
                        </button> */}
            <button
              class="button button-primary"
              type="submit"
              onClick={(e) => setSuccessPrAssign(false)}
            >
              Okay
            </button>
            <div className="helpPopupText pb-0">
              <div>Need help? Write to us at</div>
              <div>
                <a href={`mailto:${helpEmailForAssignedArticle}`}>
                  {helpEmailForAssignedArticle}
                </a>
              </div>
            </div>
          </Modal.Footer>
        </Modal>
        <Modal
          show={addPeerReviewerPop}
          onHide={handleClose}
          dialogClassName="modal-dialog-centered modal-lg authorModal"
        >
          <Modal.Header className="modal-header">
            <h5 className="modal-title">Add Peer Reviewers</h5>
            <button
              type="button"
              className="btn-close"
              ariaLabel="Close"
              onClick={(e) => setaddPeerReviewerPop(false)}
            />
          </Modal.Header>
          <Modal.Body className="pb-0">
            <div className="peerreview">
              {peerreviewlist.map((val, ind) => (
                <div className="" key={ind}>
                  <div className="d-flex justify-content-between px-3">
                    <p className="theme-orange-color text-start fs-6 fw-bold mb-3">
                      Peer Reviewer {ind + 1}
                    </p>
                    <p
                      onClick={(e) => handleRemove(ind)}
                      className="theme-blue-color text-start pe-1 fs-6 fw-bold mb-3"
                      style={{ cursor: "pointer" }}
                    >
                      Remove
                    </p>
                  </div>
                  <div className="row mb-3 px-3">
                    <div className="col-6">
                      <label className="labelForm text-black p-0">Name</label>
                      <input
                        className="form-control"
                        value={val.name}
                        type="text"
                        onChange={(e) =>
                          invitePEhandleUpdate(ind, { name: e.target.value })
                        }
                        placeholder="Full Name"
                      />
                    </div>
                    <div className="col-6">
                      <label className="labelForm text-black p-0">
                        Email ID
                      </label>
                      <input
                        className="form-control"
                        value={val.email}
                        onChange={(e) =>
                          invitePEhandleUpdate(ind, { email: e.target.value })
                        }
                        type="text"
                        placeholder="Email"
                      />
                    </div>
                  </div>
                  <div className="row mb-4 px-3">
                    <div className="col-6">
                      <label className="labelForm text-black p-0">
                        Affiliated Institution/University
                      </label>
                      <input
                        className="form-control"
                        value={val.university}
                        onChange={(e) =>
                          invitePEhandleUpdate(ind, {
                            university: e.target.value,
                          })
                        }
                        type="text"
                        placeholder="Affiliated Institution/University"
                      />
                    </div>
                    <div className="col-6">
                      <label className="labelForm text-black p-0">
                        Subject
                      </label>
                      <input
                        className="form-control"
                        value={val.subject}
                        onChange={(e) =>
                          invitePEhandleUpdate(ind, { subject: e.target.value })
                        }
                        type="text"
                        placeholder="Subject"
                      />
                      <div className="selectBox">
                        {/* <Select
                                    // selectedValue={
                                    //   reviewerDetails?.specialization[index].val
                                    // }
                                    options={Subjectmaster.specializationList?.map(
                                      (val) => val?.specialization
                                    )}
                                    optionValues={Subjectmaster.specializationList?.map(
                                      (val) => val?._id
                                    )}
                                    // name={`specialization${index}`}
                                    placeholder="Search and Select"
                                    // handleChange={(e) =>
                                    //   handleSelectChangesReviewer(
                                    //     e,
                                    //     index,
                                    //     "specialization"
                                    //   )
                                    // }
                                    required={true}
                                    mandatory={false}
                                    isSearchable={true}
                                    
                                  /> */}
                      </div>
                    </div>
                  </div>
                  <hr />
                </div>
              ))}
              <a
                className="d-block text-start fw-bold"
                onClick={(e) => {
                  handleAdd();
                }}
              >
                + Add More Peer Reviewer
              </a>
            </div>
          </Modal.Body>
          <Modal.Footer className="pb-4">
            <button
              class="button button-primary"
              type="submit"
              onClick={handleInviteSubmit}
            >
              Submit
            </button>
          </Modal.Footer>
        </Modal>
      </DashboardLayout>
    </>
  );
};
export default PRListing;
